import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect, useLayoutEffect } from 'react';
export function useFromStore(store, key) {
  var _useState = useState(store.getItem(key)),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    store.subscribeToItem(key, setState);
    return function () {
      return store.unsubscribeFromItem(key, setState);
    };
  }, [store, key]);
  return state;
}
export function useEffectFromStore(store, key, handleChange) {
  var dependencies = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  return useEffect(function () {
    store.subscribeToItem(key, handleChange);
    return function () {
      return store.unsubscribeFromItem(key, handleChange);
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [store, key, handleChange].concat(_toConsumableArray(dependencies)));
}
export function useLayoutEffectFromStore(store, key, handleChange, dependencies) {
  return useLayoutEffect(function () {
    store.subscribeToItem(key, handleChange);
    return function () {
      return store.unsubscribeFromItem(key, handleChange);
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [store, key, handleChange].concat(_toConsumableArray(dependencies)));
}
export default function createStore(initialState) {
  var state = initialState || {};
  var listeners = {};

  var subscribeToItem = function subscribeToItem(key, callback) {
    listeners[key] = listeners[key] || [];
    listeners[key].push(callback);
  };

  var unsubscribeFromItem = function unsubscribeFromItem(key, callback) {
    if (!listeners[key]) return;
    listeners[key] = listeners[key].filter(function (listener) {
      return listener !== callback;
    });
  };

  var updateItem = function updateItem(key, item) {
    if (state[key] === item) return;

    if (typeof item === 'function') {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      state[key] = item.apply(void 0, [state[key]].concat(args));
    } else {
      state[key] = item;
    }

    if (listeners[key]) {
      listeners[key].forEach(function (listener) {
        return listener(state[key]);
      });
    }
  };

  var getItem = function getItem(key) {
    return state[key];
  };

  var reset = function reset() {
    state = initialState || {};
    listeners = {};
  };

  return {
    subscribeToItem: subscribeToItem,
    unsubscribeFromItem: unsubscribeFromItem,
    updateItem: updateItem,
    getItem: getItem,
    reset: reset
  };
}